module.exports = __webpack_public_path__ + "img/busIcon3.199001ef.png";